var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.0074 21.7895C17.1169 22.8836 14.893 23.2529 12.7504 22.8285C10.6077 22.404 8.69253 21.2148 7.36191 19.4826C6.03128 17.7504 5.37602 15.5934 5.51831 13.4138C5.66059 11.2341 6.5907 9.18058 8.13523 7.63605C9.67976 6.09152 11.7333 5.16141 13.9129 5.01913C16.0926 4.87684 18.2496 5.5321 19.9818 6.86272C21.714 8.19335 22.9032 10.1085 23.3276 12.2512C23.7521 14.3938 23.3828 16.6177 22.2887 18.5082L23.4615 22.0098C23.5055 22.1419 23.5119 22.2838 23.4799 22.4193C23.448 22.5549 23.3788 22.6789 23.2803 22.7774C23.1818 22.8759 23.0578 22.945 22.9223 22.977C22.7867 23.009 22.6449 23.0026 22.5127 22.9585L19.0074 21.7895Z",
    stroke: "#4D5468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12H13.5",
    stroke: "#4D5468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11C9.94772 11 9.5 11.4477 9.5 12C9.5 12.5523 9.94772 13 10.5 13Z",
    fill: "#4D5468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16H13.5",
    stroke: "#4D5468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17C11.0523 17 11.5 16.5523 11.5 16C11.5 15.4477 11.0523 15 10.5 15C9.94772 15 9.5 15.4477 9.5 16C9.5 16.5523 9.94772 17 10.5 17Z",
    fill: "#4D5468"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.92a3e37f44672e33a8b824db91bcaea8.svg";
export { ForwardRef as ReactComponent };